// Enables the "Allow access" button as soon as a workspace is picked,
// without waiting for the server round-trip (phx-change) to re-render it.
export default {
  mounted() {
    this.toggle()
    this.el.addEventListener("change", () => this.toggle())
  },
  updated() {
    this.toggle()
  },
  toggle() {
    const btn = document.getElementById(this.el.dataset.approveButtonId)
    if (!btn) return
    btn.disabled = this.el.value === ""
  }
}
